import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAppConfig } from "../api/configApi";

const initialConfig = {
  stage: "dev",
  signupsOpen: true,
  paymentSystemEnabled: false,
  betaFeatureEnabled: false,
  realtimeDisabled: false,
  dailyRealtimeSessionsCap: 0,
  maxRealtimeMinutes: 0,
};

export const fetchFeatureConfig = createAsyncThunk(
  "feature/fetchFeatureConfig",
  async (_, { rejectWithValue }) => {
    try {
      const cfg = await getAppConfig();
      return {
        stage: cfg?.stage || "dev",
        signupsOpen: cfg?.signupsOpen ?? true,
        paymentSystemEnabled: Boolean(cfg?.paymentSystemEnabled),
        betaFeatureEnabled: Boolean(cfg?.betaFeatureEnabled),
        realtimeDisabled: Boolean(cfg?.realtimeDisabled),
        dailyRealtimeSessionsCap: Number(cfg?.dailyRealtimeSessionsCap || 0),
        maxRealtimeMinutes: Number(cfg?.maxRealtimeMinutes || 0),
      };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error || err?.message || "Failed to fetch config");
    }
  }
);

const featureSlice = createSlice({
  name: "feature",
  initialState: {
    data: initialConfig,
    loading: false,
    error: null,
    bootstrapped: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeatureConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.bootstrapped = true;
        state.data = action.payload;
      })
      .addCase(fetchFeatureConfig.rejected, (state, action) => {
        state.loading = false;
        state.bootstrapped = true;
        state.error = action.payload || "Failed to fetch config";
      });
  },
});

export default featureSlice.reducer;

export const selectFeatureConfig = (state) => state.feature.data;
export const selectPaymentSystemEnabled = (state) => Boolean(state.feature?.data?.paymentSystemEnabled);
export const selectBetaFeatureEnabled = (state) => Boolean(state.feature?.data?.betaFeatureEnabled);
